import React, { createContext, useContext, useReducer } from 'react';
import { reducer, initialState, State } from './reducers';
import { Action } from './actions';

const AppContext = createContext<{ state: State; dispatch: React.Dispatch<Action> }>({
  state: initialState,
  dispatch: undefined
});

export const StoreProvider: React.ComponentType = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
};

export const useStore = (): { state: State; dispatch: React.Dispatch<Action> } => {
  return useContext(AppContext);
};
